import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M14.5 9.5H9.5V14.5H14.5V9.5Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M9 0.5V3H15V0.5H17V3H21V7H23.5V9H21V15H23.5V17H21V21H17V23.5H15V21H9V23.5H7V21H3V17H0.5V15H3V9H0.5V7H3V3H7V0.5H9ZM7.5 7.5V16.5H16.5V7.5H7.5Z"}}]};

const CpuFilled = Vue.extend<IconProps>({
  name: 'CpuFilledIcon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'cpu-filled',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default CpuFilled;
